import PosBankGird from './bank/PosBankGird'
import DevicePage from './device/index'
import EnterpriseRcbGrid from './enterpriseRcb/EnterpriseRcbGrid'
import FundPage from './fund/index'
import GetinPage from './getin/index'
import MerchantPage from './merchant/index'
import ProjectFund from './projectfund/index'
import SealManageGrid from './sealmanage/SealManageGrid'
import TemplateGird from './template/TemplateGird'

const routes: IRoute[] = [
  {
    path: '/661010',
    component: GetinPage,
    name: '收款明细',
  },
  {
    path: '/661011',
    component: TemplateGird,
    name: '收据模板管理',
  },
  {
    path: '/661015',
    component: SealManageGrid,
    name: '项目印章管理',
  },
  {
    path: '/661018',
    component: ProjectFund,
    name: '项目印章管理',
  },

  {
    path: '/661020',
    component: EnterpriseRcbGrid,
    name: '企业注册认证',
  },

  {
    path: '/662010',
    component: DevicePage,
    name: '设备管理',
  },


  {
    path: '/662005',
    component: FundPage,
    name: '款项名称',
  },
  {
    path: '/662006',
    component: PosBankGird,
    name: '入账银行',
  },
  {
    path: '/662012',
    component: MerchantPage,
    name: '银联商户',
  },
]

export default routes



// WEBPACK FOOTER //
// ./src/page/pos/index.tsx